<template>
    <aside aria-label="Site menu">
        <slide-in-menu :is-open="isOpen" @close="close" class="c-sitemenu">
			<template v-slot:tools><slot name="tools"></slot></template>
            <template v-slot:body><slot name="body"></slot></template>
        </slide-in-menu>
    </aside>
</template>

<script>
import SlideInMenu from '../components/SlideInMenu.vue'

export default {
    name: 'SiteMenu',
    components: {
        SlideInMenu,
    },
    data: () => {
        return {}
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            this.$store.commit('setSlideInState', false)
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/base/variables.scss';

.c-sitemenu {
    &__heading {
        position: relative;
        margin-bottom: 16px;
    }
}
</style>
